var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useMemo, useState } from 'react';
import { Button, Card, Image, Modal, Space, Table, Typography, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { deleteAdminConversationMessage, fetchAdminConversationMessages } from '../cores/api/api-admin-messages';
import { ADMIN_MESSAGES_QUERY_KEY } from '../contants/option';
dayjs.extend(utc);
dayjs.extend(timezone);
const JAPAN_TIMEZONE = 'Asia/Tokyo';
const Text = Typography.Text;
const formatDatetime = value => {
    if (!value)
        return '-';
    return dayjs(value).tz(JAPAN_TIMEZONE).format('YYYY/MM/DD HH:mm:ss');
};
const readRecommendId = () => {
    const el = document.getElementById('react-admin-messages-page');
    const raw = (el === null || el === void 0 ? void 0 : el.getAttribute('data-recommend-id')) || new URLSearchParams(window.location.search).get('id');
    if (!raw || !/^\d+$/.test(raw))
        return null;
    return Number(raw);
};
const previewText = record => {
    if (record.message_type === 'image') {
        return record.images.length ? `画像 ${record.images.length}枚` : '(image)';
    }
    const text = (record.content || '').trim();
    if (!text)
        return '';
    return text.length > 80 ? `${text.slice(0, 80)}…` : text;
};
export default function AdminMessagesPage() {
    var _a, _b, _c, _d, _e, _f, _g;
    const recommendId = useMemo(() => readRecommendId(), []);
    const _message$useMessage = message.useMessage(), _message$useMessage2 = _slicedToArray(_message$useMessage, 2), messageApi = _message$useMessage2[0], contextHolder = _message$useMessage2[1];
    const queryClient = useQueryClient();
    const _useState = useState(1), _useState2 = _slicedToArray(_useState, 2), page = _useState2[0], setPage = _useState2[1];
    const _useState3 = useState(20), _useState4 = _slicedToArray(_useState3, 2), perPage = _useState4[0], setPerPage = _useState4[1];
    const _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), deleteTarget = _useState6[0], setDeleteTarget = _useState6[1];
    const apiFilters = useMemo(() => ({
        recommend_id: recommendId,
        page,
        per_page: perPage
    }), [recommendId, page, perPage]);
    const _useQuery = useQuery({
        queryKey: [...ADMIN_MESSAGES_QUERY_KEY, apiFilters],
        queryFn: () => fetchAdminConversationMessages(apiFilters),
        enabled: recommendId != null,
        keepPreviousData: true
    }), data = _useQuery.data, isLoading = _useQuery.isLoading, isFetching = _useQuery.isFetching;
    const deleteMutation = useMutation({
        mutationFn: id => deleteAdminConversationMessage(id),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.success) {
                throw new Error(response.error || 'Delete failed');
            }
            yield queryClient.invalidateQueries({
                queryKey: ADMIN_MESSAGES_QUERY_KEY
            });
            messageApi.success(response.message || 'メッセージを削除しました');
            setDeleteTarget(null);
        }),
        onError: error => {
            messageApi.error(error.message);
        }
    });
    const handleTableChange = pagination => {
        var _a, _b;
        setPage((_a = pagination.current) !== null && _a !== void 0 ? _a : 1);
        setPerPage((_b = pagination.pageSize) !== null && _b !== void 0 ? _b : 20);
    };
    const conversation = data === null || data === void 0 ? void 0 : data.conversation;
    const male = conversation === null || conversation === void 0 ? void 0 : conversation.male;
    const female = conversation === null || conversation === void 0 ? void 0 : conversation.female;
    const columns = [{
            title: '送信者',
            width: '18%',
            render: (_, record) => /*#__PURE__*/ React.createElement("span", {
                className: "text-base",
                style: {
                    color: record.sender_sex === 2 ? '#cf1322' : '#1677ff'
                }
            }, record.sender_name || '-')
        }, {
            title: '種別',
            dataIndex: 'message_type',
            width: '10%',
            render: value => /*#__PURE__*/ React.createElement("span", {
                className: "text-base"
            }, value)
        }, {
            title: 'メッセージ',
            width: '44%',
            render: (_, record) => {
                if (record.message_type === 'image') {
                    if (!record.images.length) {
                        return /*#__PURE__*/ React.createElement(Text, {
                            type: "secondary"
                        }, "(image / no files)");
                    }
                    return /*#__PURE__*/ React.createElement(Image.PreviewGroup, null, /*#__PURE__*/ React.createElement(Space, {
                        wrap: true
                    }, record.images.map(image => image.url ? /*#__PURE__*/ React.createElement(Image, {
                        key: image.id,
                        src: image.url,
                        alt: "chat image",
                        style: {
                            maxWidth: 120,
                            maxHeight: 120,
                            objectFit: 'cover'
                        }
                    }) : /*#__PURE__*/ React.createElement(Text, {
                        key: image.id,
                        type: "secondary"
                    }, "(no url)"))));
                }
                return /*#__PURE__*/ React.createElement("div", {
                    className: "whitespace-pre-wrap break-words text-base leading-6"
                }, record.content || '-');
            }
        }, {
            title: '送信日時',
            dataIndex: 'created_at',
            width: '18%',
            render: value => /*#__PURE__*/ React.createElement("span", {
                className: "whitespace-nowrap text-base"
            }, formatDatetime(value))
        }, {
            title: '操作',
            width: '10%',
            render: (_, record) => /*#__PURE__*/ React.createElement(Button, {
                size: "small",
                danger: true,
                disabled: deleteMutation.isPending,
                onClick: () => setDeleteTarget(record)
            }, "\u524A\u9664")
        }];
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-full overflow-x-hidden bg-[#f5f5f5] px-6 py-2"
    }, contextHolder, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto w-full max-w-[960px]"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "mb-0 text-[2.5rem] font-medium leading-tight text-[#212529]"
    }, (male === null || male === void 0 ? void 0 : male.name) || '-', " | ", (_a = male === null || male === void 0 ? void 0 : male.id) !== null && _a !== void 0 ? _a : '-', " - ", (female === null || female === void 0 ? void 0 : female.name) || '-', " | ", (_b = female === null || female === void 0 ? void 0 : female.id) !== null && _b !== void 0 ? _b : '-', " \u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u4E00\u89A7"), /*#__PURE__*/ React.createElement(Space, {
        className: "mt-2 text-[12px]"
    }, (male === null || male === void 0 ? void 0 : male.id) ? /*#__PURE__*/ React.createElement("a", {
        href: `/userpage?id=${male.id}`,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-blue-600 hover:underline text-[12px]"
    }, "\u7537\u6027\u30DA\u30FC\u30B8") : null, (female === null || female === void 0 ? void 0 : female.id) ? /*#__PURE__*/ React.createElement("a", {
        href: `/userpage?id=${female.id}`,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-blue-600 hover:underline text-[12px]"
    }, "\u5973\u6027\u30DA\u30FC\u30B8") : null, /*#__PURE__*/ React.createElement("span", {
        className: "text-[13px] text-[#374151]"
    }, (_d = (_c = data === null || data === void 0 ? void 0 : data.meta) === null || _c === void 0 ? void 0 : _c.total_count) !== null && _d !== void 0 ? _d : 0, " \u4EF6"))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        className: "text-base [&_th]:text-base [&_td]:text-base",
        loading: isLoading || isFetching,
        columns: columns,
        dataSource: (_e = data === null || data === void 0 ? void 0 : data.data) !== null && _e !== void 0 ? _e : [],
        tableLayout: "fixed",
        pagination: {
            current: page,
            pageSize: perPage,
            total: (_g = (_f = data === null || data === void 0 ? void 0 : data.meta) === null || _f === void 0 ? void 0 : _f.total_count) !== null && _g !== void 0 ? _g : 0,
            showSizeChanger: true
        },
        onChange: handleTableChange,
        locale: {
            emptyText: 'メッセージはありません'
        }
    }))), /*#__PURE__*/ React.createElement(Modal, {
        title: "\u672C\u5F53\u306B\u524A\u9664\u3057\u307E\u3059\u304B?",
        open: deleteTarget != null,
        onCancel: () => setDeleteTarget(null),
        onOk: () => {
            if (deleteTarget)
                return deleteMutation.mutateAsync(deleteTarget.id);
        },
        confirmLoading: deleteMutation.isPending,
        okText: "\u6D88\u53BB",
        okButtonProps: {
            danger: true
        },
        cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB",
        destroyOnClose: true,
        zIndex: 1200
    }, /*#__PURE__*/ React.createElement("p", null, "\u3053\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u5B8C\u5168\u306B\u524A\u9664\u3057\u307E\u3059\u3002\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002"), deleteTarget ? /*#__PURE__*/ React.createElement("p", {
        className: "mt-2 text-[#666]"
    }, "\u5BFE\u8C61: ", previewText(deleteTarget) || '-') : null));
}
